import type { ReactNode } from 'react';

import type { TerminalCopy } from '../features/links/stateCopy';

type TerminalStateProps = {
  copy: TerminalCopy;
  action?: ReactNode;
};

export function TerminalState({ copy, action }: TerminalStateProps) {
  return (
    <section className={`surface terminal terminal--${copy.tone}`} aria-live="polite">
      {copy.eyebrow ? <p className="eyebrow">{copy.eyebrow}</p> : null}
      <h1>{copy.title}</h1>
      <p>{copy.body}</p>
      {action ? <div className="terminal__action">{action}</div> : null}
    </section>
  );
}
